module.exports = __webpack_public_path__ + "resources/img/mark_27001_lg.1d03af0c301f0fa6b70c859fab5bd04b.png";